"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTables = void 0;
const organism_1 = require("./organism");
const props_1 = require("../common/props");
/**
 * The data tables organism.
 * @category Organisms
 */
class DataTables extends organism_1.Organism {
    constructor(organisms) {
        super("Data Tables", organisms);
        this.availableColors = new props_1.PropertyStringSelectable("Available Colors", false, this, { selectables: ["Colored", "Black", "White"] });
        this.padding = new props_1.PropertyPixelSelectable("Table Padding", false, this, [4, 8, 16]);
        this.headerText = new props_1.PropertyButtonText("Table Header Text", false, this);
        this.shadow = new props_1.PropertyShadowSelectable("Avatar Shadow", false, this);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.availableColors.deserialize(obj.availableColors);
        this.padding.deserialize(obj.padding);
        this.headerText.deserialize(obj.headerText);
        this.shadow.deserialize(obj.shadow);
    }
    serialize() {
        const obj = {};
        obj.availableColors = this.availableColors.serialize();
        obj.padding = this.padding.serialize();
        obj.headerText = this.headerText.serialize();
        obj.shadow = this.shadow.serialize();
        return obj;
    }
}
exports.DataTables = DataTables;
